import * as React from 'react';
import Select from '../TheSelect';
const AsyncSelect = ({ defaultOptions, loadOptions, loadDefaultOptions, value, onChange, onBlur, onChangeInput, inputValue, setInputValue, ...restProps }) => {
    const [componentDefaultOptions, setComponentDefaultOptions] = React.useState(defaultOptions);
    const [options, setOptions] = React.useState(componentDefaultOptions || []);
    const [localInputValue, setLocalInputValue] = React.useState('');
    const [isLoadingDefaultOptions, setIsLoadingDefaultOptions] = React.useState(false);
    const [isLoadingFilteredOptions, setIsLoadingFilteredOptions] = React.useState(false);
    const timerRef = React.useRef();
    React.useEffect(() => {
        if (loadDefaultOptions) {
            setIsLoadingDefaultOptions(true);
            loadDefaultOptions()
                .then(res => {
                setComponentDefaultOptions(res);
            })
                .catch(e => {
                console.error(e);
            })
                .finally(() => {
                setIsLoadingDefaultOptions(false);
            });
        }
    }, [loadDefaultOptions]);
    const handleChangeInputValue = (newInputValue) => {
        !!onChangeInput && onChangeInput(newInputValue);
        !!setInputValue
            ? setInputValue(newInputValue)
            : setLocalInputValue(newInputValue);
        if (newInputValue.length >= 3) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => {
                if (!!loadOptions) {
                    setIsLoadingFilteredOptions(true);
                    loadOptions(newInputValue)
                        .catch(console.error)
                        .then(res => {
                        setOptions(res || []);
                    })
                        .finally(() => {
                        setIsLoadingFilteredOptions(false);
                    });
                }
            }, 200);
        }
        else {
            setOptions([]);
        }
    };
    return (React.createElement(Select, { ...restProps, value: value, filterOptions: null, onChange: onChange, onBlur: inputEl => {
            !!setInputValue ? setInputValue('') : setLocalInputValue('');
            if (onBlur) {
                onBlur(inputEl);
            }
        }, loading: isLoadingDefaultOptions || isLoadingFilteredOptions, options: inputValue === '' ? componentDefaultOptions || [] : options, onChangeInput: handleChangeInputValue, inputValue: inputValue || localInputValue, setInputValue: setInputValue || setLocalInputValue }));
};
export default AsyncSelect;
